'use strict';

var React = require('react');
var styled = require('styled-components');
var breakpoints = require('./breakpoints.js');
var index = require('./design-tokens/index.js');
var theme = require('./theme.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const ThemeProvider = ({ children, theme: theme$1 = theme.theme }) => {
    const themeWithDesignTokens = React.useMemo(() => ({
        ...theme$1,
        designTokens: { ...index.designTokens(theme$1), ...theme$1.designTokens },
        deviceMediaQueries: breakpoints.makeMediaQueries(theme$1.devices),
    }), [theme$1]);
    return React__default.default.createElement(styled.ThemeProvider, { theme: themeWithDesignTokens }, children);
};

Object.defineProperty(exports, 'useTheme', {
    enumerable: true,
    get: function () { return styled.useTheme; }
});
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=Provider.js.map
